import { jsx, jsxs } from "react/jsx-runtime";
import { Icon } from "@blueprintjs/core";
import React from "react";
import { orfIcon, CmdCheckbox, CmdDiv, InfoHelper } from "@teselagen/ui";
import ToolbarItem from "./ToolbarItem";
import { connectToEditor } from "../withEditorProps";
import withEditorProps from "../withEditorProps";
import getCommands from "../commands";
export default connectToEditor(
  ({ annotationVisibility = {}, toolBar = {} }) => {
    return {
      toggled: annotationVisibility.orfs,
      isOpen: toolBar.openItem === "orfTool"
    };
  }
)(({ toolbarItemProps, toggled, annotationVisibilityToggle, isOpen }) => {
  return /* @__PURE__ */ jsx(
    ToolbarItem,
    {
      ...{
        Icon: /* @__PURE__ */ jsx(Icon, { "data-test": "orfTool", icon: orfIcon }),
        onIconClick: function() {
          annotationVisibilityToggle("orfs");
        },
        toggled,
        tooltip: "Show Open Reading Frames",
        tooltipToggled: "Hide Open Reading Frames",
        Dropdown: OrfToolDropdown,
        dropdowntooltip: (!isOpen ? "Show" : "Hide") + " Open Reading Frame Options",
        ...toolbarItemProps
      }
    }
  );
});
const OrfToolDropdown = withEditorProps(
  class OrfDropdown extends React.Component {
    constructor(props) {
      super(props);
      this.commands = getCommands(this);
    }
    render() {
      return /* @__PURE__ */ jsxs("div", { className: "veToolbarOrfOptionsHolder", children: [
        /* @__PURE__ */ jsx(
          CmdCheckbox,
          {
            prefix: "Show ",
            cmd: this.commands.toggleOrfTranslations
          }
        ),
        /* @__PURE__ */ jsx(
          CmdCheckbox,
          {
            prefix: "Show ",
            cmd: this.commands.useGtgAndCtgAsStartCodons
          }
        ),
        /* @__PURE__ */ jsx(CmdDiv, { cmd: this.commands.minOrfSizeCmd }),
        /* @__PURE__ */ jsx("div", { className: "vespacer" }),
        /* @__PURE__ */ jsx(
          InfoHelper,
          {
            displayToSide: true,
            content: "To translate an arbitrary area, right click a selection."
          }
        )
      ] });
    }
  }
);
